// src/pages/Schedules.tsx
import { useState } from "react";
import { Calendar, BarChart3, Mail, Clock, FileText, TrendingUp } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SchedulesDashboard } from "@/components/schedules/SchedulesDashboard";
import { SchedulesReports } from "@/components/schedules/SchedulesReports";
import { SchedulesRecipients } from "@/components/schedules/SchedulesRecipients";
import { SchedulesPlanning } from "@/components/schedules/SchedulesPlanning";
import { SchedulesHistory } from "@/components/schedules/SchedulesHistory";

export default function Schedules() {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <div className="min-h-screen bg-background">
      {/* Bandeau */}
      <div className="bg-gradient-primary text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-transparent to-primary/20" />
        <div className="relative max-w-7xl mx-auto px-6 py-10">
          <div className="text-center space-y-3 animate-in fade-in-0 slide-in-from-top-4 duration-500">
            <div className="inline-flex items-center justify-center gap-3">
              <div className="p-3 rounded-xl bg-white/10 ring-1 ring-white/20 backdrop-blur-sm">
                <Calendar className="h-6 w-6" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold">
                Distribution automatique des rapports
              </h1>
            </div>
            <p className="text-white/90 max-w-3xl mx-auto">
              Configurez l'envoi automatique de vos rapports par email. Gérez les rapports, les
              destinataires et les plannings d'envoi.
            </p>
          </div>
        </div>
      </div>

      {/* Contenu avec Tabs */}
      <div className="max-w-7xl mx-auto px-6 py-10">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-5 lg:w-auto">
            <TabsTrigger value="dashboard" className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4" />
              <span className="hidden sm:inline">Tableau de bord</span>
            </TabsTrigger>
            <TabsTrigger value="reports" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              <span className="hidden sm:inline">Rapports</span>
            </TabsTrigger>
            <TabsTrigger value="recipients" className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <span className="hidden sm:inline">Destinataires</span>
            </TabsTrigger>
            <TabsTrigger value="planning" className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              <span className="hidden sm:inline">Planning</span>
            </TabsTrigger>
            <TabsTrigger value="history" className="flex items-center gap-2">
              <TrendingUp className="h-4 w-4" />
              <span className="hidden sm:inline">Historique</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard" className="space-y-4">
            <SchedulesDashboard />
          </TabsContent>

          <TabsContent value="reports" className="space-y-4">
            <SchedulesReports />
          </TabsContent>

          <TabsContent value="recipients" className="space-y-4">
            <SchedulesRecipients />
          </TabsContent>

          <TabsContent value="planning" className="space-y-4">
            <SchedulesPlanning />
          </TabsContent>

          <TabsContent value="history" className="space-y-4">
            <SchedulesHistory />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
